import { DeviceAlert } from "../deviceAlert";

export type RawDeviceV2 = {
  readonly id: string;
  readonly code: string;
  readonly currencies: string[];

  readonly active: boolean;
  readonly manufacturer: string;
  readonly model: string;
  readonly name: string;

  readonly type: string;
  readonly manufacturerNoteCapacity: number;
  readonly realNoteCapacity: number;
  readonly prosegurNoteCapacity: number;
  readonly manufacturerCoinCapacity: number;
  readonly realCoinCapacity: number;
  readonly prosegurCoinCapacity: number;
  readonly clientMode: string;
  readonly countryCode: string;
  readonly deviceAlerts: DeviceAlert[];
};

export const iniRawDeviceV2: RawDeviceV2 = {
  id: "",
  name: "",
  code: "",
  type: "",
  model: "",
  manufacturer: "",
  currencies: [],
  active: true,
  manufacturerNoteCapacity: 0,
  realNoteCapacity: 0,
  prosegurNoteCapacity: 0,
  manufacturerCoinCapacity: 0,
  realCoinCapacity: 0,
  prosegurCoinCapacity: 0,
  deviceAlerts: [],
  countryCode: "",
  clientMode: "",
};
